import { CacheData } from './cache-data';
export interface InstantConfigCacheStorageService {
	set(data: CacheData): void;
	get(id: string): CacheData | undefined;
}
